import { useCallback } from 'react'
import type { RouterInputs } from '@klear/ui/lib/trpc'
import { trpc } from '@klear/ui/lib/trpc'

export function useOperationalMutations() {
  const previewMutation = trpc.operational.preview.useMutation()
  const commitMutation = trpc.operational.commit.useMutation()

  const previewOperational = useCallback(
    (input: RouterInputs['operational']['preview']) => previewMutation.mutateAsync(input),
    [previewMutation.mutateAsync]
  )

  const commitOperational = useCallback(
    (input: RouterInputs['operational']['commit']) => commitMutation.mutateAsync(input),
    [commitMutation.mutateAsync]
  )

  return {
    previewOperational,
    commitOperational,
    isPreviewing: previewMutation.isPending,
    isCommitting: commitMutation.isPending
  }
}
